module.exports = __webpack_public_path__ + "d03da03324a2ee91f554eacc3d20000c.png";